
import { defineComponent, PropType } from 'vue'
import { EnterpriseUser } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'
import { getDefaultAvatar } from '~/utils/ui'

interface EnterpriseUserWithCounts extends EnterpriseUser {
  groupsCount: {
    totalCount: number
  }
}

export default defineComponent({
  name: 'ControlPanelUserHeader',
  props: {
    orgUser: {
      type: Object as PropType<EnterpriseUserWithCounts>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getDefaultAvatar,
    parseISODate,
    formatDate
  }
})
